import TaxReceiptHint from './TaxReceiptHint'

export default TaxReceiptHint
